import * as $ from "jquery";

function showInMainPane(button, popup, fixWidth?) {
  popup.show();
  let height = popup.outerHeight();
  let width = popup.outerWidth();
  let innerWidth = popup.width();
  let leftPaneWidth = $('.left-line').outerWidth();
  let sheetOffset = $('.linesheet-w').offset();
  let buttonOffset = button.offset();
  let windowWidth = $(window).innerWidth();
  let top = buttonOffset.top - height;
  let left = buttonOffset.left - (width / 2);
  let padding = 10;

  if (top < (sheetOffset.top + padding)) {
    top = sheetOffset.top + padding;
  }
  if ((top + height) > buttonOffset.top) {
    let newTop = buttonOffset.top + button.outerHeight();
    if ((newTop + height) < $(window).innerHeight()) {
      top = newTop;
    }
  }

  let minLeft = sheetOffset.left + leftPaneWidth + padding;
  if (left < minLeft) {
    left = minLeft;
  } else if ((left + width + padding) > windowWidth) {
    left = windowWidth - width - padding;
  }
  popup.offset({ top: top, left: left });
  if (fixWidth) {
    popup.width(innerWidth);
  }
}

export default function initializePopups() {
  $(window.document).ready(function () {
    $(window.document).on('click', '.add-menu-trigger', function (event) {
      let menuButton = $(this);
      let menu = menuButton.prev('.add-menu');
      if (menu.is(':hidden')) {
        $('.add-menu:visible').hide();
        $('.lineitem-hoverover:visible').hide();

        showInMainPane(menuButton, menu, true);
      } else {
        menu.hide();
      }
      event.stopPropagation();
    });

    $(window.document).on('click', '.size-toggler', (event) => { 
      $('.showable').toggleClass('is-hidden-small');
      $('.content-center').toggleClass('move-right-80');  
      event.stopPropagation();
    });

    let currentHover = null;
    let shownHover = null;
    let hideHover = null;
    let hoverShowTimeout = null;
    let hoverHideTimeout = null;
    let setHoverShowTimeout = function (hover, lineItem, event) {
      hoverShowTimeout = setTimeout(function () {
        hoverShowTimeout = null;
        shownHover = hover[0];

        if (hover.is(':hidden')) {
          $('.add-menu:visible').hide();
          $('.lineitem-hoverover:visible').hide();
        } else {
          $('.lineitem-hoverover:visible').show();
        }

        showInMainPane(lineItem, hover);
      }, 500);
      event.stopPropagation();
    };
    let setHoverHideTimeout = function (hover) {
      if (hover === hideHover) {
        return;
      }

      hideHover = hover;
      if (hoverShowTimeout) {
        clearTimeout(hoverShowTimeout);
        hoverShowTimeout = null;
      }

      hoverHideTimeout = setTimeout(function () {
        hoverHideTimeout = null;
        hideHover = null;

        if (hover === shownHover) {
          $(shownHover).hide();
          shownHover = null;
        }
      }, 500);
      event.stopPropagation();
    };
    let onMouseOut = function (event) {
      if (!currentHover) {
        return;
      }
      if (event.currentTarget !== event.target) {
        return;
      }

      for (let i = 0; i < event.currentTarget.children.length; i++) {
        if (event.toElement === event.currentTarget.children[i]) {
          return;
        }
      }
      setHoverHideTimeout(currentHover);
    };
    $(window.document).on('mouseover', 'span.lineitem', function (event) {
      let lineItem = $(this);
      let hover = lineItem.prev('.lineitem-hoverover');
      if (hover.length === 0) {
        return;
      }

      let thisHover = hover[0];
      if (thisHover === shownHover) {
        if (hoverHideTimeout) {
          clearTimeout(hoverHideTimeout);
          hoverHideTimeout = null;
          hideHover = null;
        }
        //return;
      }

      if (hoverShowTimeout) {
        clearTimeout(hoverShowTimeout);
        hoverShowTimeout = null;
      }
      setHoverShowTimeout(hover, lineItem, event);
      currentHover = thisHover;
    });
    $(window.document).on('mouseover', '.lineitem-hoverover', function () {
      let hover = $(this);
      if (hover.length === 0) {
        return;
      }
      if (shownHover === hover[0] && hoverHideTimeout) {
        clearTimeout(hoverHideTimeout);
        hoverHideTimeout = null;
        hideHover = null;
      }
      event.stopPropagation();
    });
    $(window.document).on('mouseout', 'span.lineitem', onMouseOut);
    $(window.document).on('mouseout', '.lineitem-hoverover', onMouseOut);
    $(window.document).on('click', '.lineitem-hoverover', function (event) {
      event.stopPropagation();
    });
    $(window.document).on('click', function () {
      $('.add-menu:visible').hide();
      $('.lineitem-hoverover:visible').hide();
    });
    $(window.document).on('click', '.toggle-zoom', function () {
      $('.linesheet-w').toggleClass('zoom-out-eighty');
      $('.toggle-zoom i').toggleClass('fa-search-minus fa-search-plus');
    });
    $(window.document).on('click', '.toggle-collapse', function () {
      $('.linedash-w, .topbox').slideToggle('slow');
      $('.toggle-collapse i').toggleClass('fa-eye-slash fa-eye');
    });
    $(window.document).on('click', '.toggle-hiding', function () {
      $('.hideable').slideToggle('fast');
      $('.hourly-zoomable').toggleClass('zoom-in-onethirty');
      $('.toggle-hiding i').toggleClass('fa-plus fa-minus');
    });
    $(window.document).on('click', '.expand-mobile', function () {
      $('.hideable-mobile').slideToggle('fast');
      $('.hours-columns').toggleClass('collapsed expanded');
      $('.expand-mobile i').toggleClass('fa-plus fa-minus');
      if ($('.expand-mobile span').text() === "Expand") {
        $('.expand-mobile span').text('Collapse');
      } else {
        $('.expand-mobile span').text('Expand');
      }
    });
  });
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/app/popups.ts